/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  applicationOverviewAriaLabel: {
    id: 'ApplicationOverview_ApplicationOverviewAriaLabel',
    defaultMessage: 'Application Overview'
  },
  overviewTitle: {
    id: 'ApplicationOverview_LabelOverviewTitle',
    defaultMessage: 'Overview'
  },
  overviewSubtitle: {
    id: 'ApplicationOverview_LabelOverviewSubtitle',
    defaultMessage: 'You are applying for the following benefits:'
  },
  stepCount: {
    id: 'ApplicationOverview_stepCount',
    defaultMessage: 'step {count}'
  },
  stepsTitle: {
    id: 'ApplicationOverview_LabelStepsTitle',
    defaultMessage: 'Please make sure you understand the following steps involved, before continuing:'
  },
  stepOneHeading: {
    id: 'ApplicationOverview_LabelStepOneHeading',
    defaultMessage: 'Prepare'
  },
  stepOneDescription_1: {
    id: 'ApplicationOverview_LabelStepOneDescription_1',
    defaultMessage: "When you apply, you'll need to give us information such as:"
  },
  stepOneDescription_2: {
    id: 'ApplicationOverview_LabelStepOneDescription_2',
    defaultMessage: 'Personal details, for example your name, SSN'
  },
  stepOneDescription_3: {
    id: 'ApplicationOverview_LabelStepOneDescription_3',
    defaultMessage: 'Income i.e. wages, child support'
  },
  stepOneDescription_4: {
    id: 'ApplicationOverview_LabelStepOneDescription_4',
    defaultMessage: 'Rent'
  },
  stepTwoHeading: {
    id: 'ApplicationOverview_LabelStepTwoHeading',
    defaultMessage: 'Apply'
  },
  stepTwoAlert: {
    id: 'ApplicationOverview_LabelStepTwo_Alert',
    defaultMessage: 'Application time:'
  },
  stepTwoTime: {
    id: 'ApplicationOverview_LabelStepTwo_Time',
    defaultMessage: '15 minutes approximately.'
  },
  stepTwoDescription_1: {
    id: 'ApplicationOverview_LabelStepTwoDescription_1',
    defaultMessage: 'Complete this application online.'
  },
  stepTwoDescription_2: {
    id: 'ApplicationOverview_LabelStepTwoDescription_2',
    defaultMessage: "After submitting, you'll get a confirmation message and a copy by email. You can print this for your records."
  },
  stepThreeHeading: {
    id: 'ApplicationOverview_LabelStepThreeHeading',
    defaultMessage: 'Verify your information'
  },
  stepThreeDescription_1: {
    id: 'ApplicationOverview_LabelStepThreeDescription_1',
    defaultMessage: 'You may need to provide us the following documents as proof:'
  },
  stepThreeDescription_2: {
    id: 'ApplicationOverview_LabelStepThreeDescription_2',
    defaultMessage: 'Identification'
  },
  stepThreeDescription_3: {
    id: 'ApplicationOverview_LabelStepThreeDescription_3',
    defaultMessage: 'Proof of address'
  },
  stepThreeDescription_4: {
    id: 'ApplicationOverview_LabelStepThreeDescription_4',
    defaultMessage: 'Rental agreement'
  },
  stepThreeDescription_5: {
    id: 'ApplicationOverview_LabelStepThreeDescription_5',
    defaultMessage: "Don't worry if you don't have them to hand, you have up to 30 days to submit them after we receive your application."
  },
  stepFourHeading: {
    id: 'ApplicationOverview_LabelStepFourHeading',
    defaultMessage: 'Interview'
  },
  stepFourDescription_a: {
    id: 'ApplicationOverview_LabelStepFourDescription_a',
    defaultMessage: 'Schedule and attend an interview.'
  },
  stepFourDescription_b: {
    id: 'ApplicationOverview_LabelStepFourDescription_b',
    defaultMessage: "Schedule and attend an interview. You'll need to show us the following documents as proof:"
  },
  stepFiveHeading: {
    id: 'ApplicationOverview_LabelStepFiveHeading',
    defaultMessage: 'Decision'
  },
  stepFiveDescription: {
    id: 'ApplicationOverview_LabelStepFiveDescription',
    defaultMessage: "Once we've processed your application, you'll get an email telling you the decision we made. This can take up to three weeks."
  },
  finalInfoOne: {
    id: 'ApplicationOverview_LabelFinalInfo',
    defaultMessage: 'You can save your application, and come back later to finish filling it out.'
  },
  finalInfoTwo: {
    id: 'ApplicationOverview_finalInfoTwo',
    defaultMessage: '{loginLink} or {signupLink} to save your application progress.'
  },
  finalInfoTwoLoginLink: {
    id: 'ApplicationOverview_finalInfoTwoLoginLink',
    defaultMessage: 'Log in'
  },
  finalInfoTwoSignupLink: {
    id: 'ApplicationOverview_finalInfoTwoSignupLink',
    defaultMessage: 'sign up'
  },
  startButton: {
    id: 'ApplicationOverview_LabelStartButton',
    defaultMessage: 'Start application'
  },
  applyForBenefitsLink: {
    id: 'ApplicationOverview_BackLink',
    defaultMessage: 'Back'
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program'
  },
  resumeOrStartAgainDialogAriaLabel: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogAriaLabel',
    defaultMessage: 'Beginning of dialog window. Escape will cancel and close the window.'
  },
  resumeOrStartAgainDialogTitle: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogTitle',
    defaultMessage: 'Application in progress'
  },
  resumeOrStartAgainDialogContent: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogContent',
    defaultMessage: 'Would you like to resume your previously saved application or {link}?'
  },
  resumeOrStartAgainDialogHyperlink: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogHyperLink',
    defaultMessage: 'start again'
  },
  resumeOrStartAgainDialogResumeButtonLabel: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogResumeButtonLabel',
    defaultMessage: 'Resume'
  },
  resumeOrStartAgainDialogCancelButtonLabel: {
    id: 'ApplicationOverview_resumeOrStartAgainDialogCancelButtonLabel',
    defaultMessage: 'Cancel'
  },
  startApplicationButtonDisabledAriaLabel: {
    id: 'ApplicationOverview_startApplicationButtonDisabledAriaLabel',
    defaultMessage: 'An application for these programs is already pending and this program does not allow multiple applications.'
  }
});